import { useAccountTotalValue } from "../../../global/utils/redux/accountSlice.tsx";
import { useAppSelector } from "../../../global/utils/redux/store.tsx";
import { Alert, Box, Typography } from "@mui/material";
import PackagingKiosk from "../../components/Packagings/PackagingKiosk.tsx";
import SendOrderButton from "../../components/SendOrderButton.tsx";
import FormattedMessageJamezz from "../../../global/components/FormattedMessageJamezz.tsx";
import { selectPiggyGiftcardAmount } from "../../../global/utils/redux/selectors/selectPiggyGiftcardAmount.tsx";
import CheckForPotentialVouchersAtCheckoutPage from "./CheckForPotentialVouchersAtCheckoutPage.tsx";
import FormatCurrency from "../../../global/components/Currencies/FormatCurrency.tsx";
import { selectAppLanguage } from "../../components/LanguageSelector/useLanguage.ts";
import { getValidTranslation } from "../../../global/utils/translations/getValidTranslation.ts";

export function ReviewOrderPage({ isValid }: { isValid?: boolean }) {
  const totalAmount = useAccountTotalValue();
  const payDirect = useAppSelector((state) => state.global.salesarea.payDirect);
  const piggyGiftcardAmount = useAppSelector(selectPiggyGiftcardAmount);
  const usePackagings = useAppSelector((state) => state.global.salesarea.use_packagings);
  const lang = useAppSelector(selectAppLanguage);
  const checkoutMessage = getValidTranslation(
    useAppSelector((state) => state.global.salesarea?.htmlTranslations?.[lang]?.checkout_message)
  );

  return (
    <Box
      sx={{
        display: "grid",
        marginY: 8,
        gridTemplate: `"packaging packaging" "p p" "b b" "m m" / 1fr 1fr`,
        gap: 2,
        justifyContent: "center",
      }}
    >
      <CheckForPotentialVouchersAtCheckoutPage />
      <Box sx={{ gridArea: "packaging" }}>{usePackagings ? <PackagingKiosk /> : null}</Box>
      <Typography
        className={"JS-CheckoutPage-TotalAmount"}
        sx={{
          fontWeight: 800,
          fontSize: (theme) => (theme.typography.fontSize * 48) / 32,
          gridArea: "p",
          textAlign: "center",
        }}
      >
        <FormatCurrency value={totalAmount - piggyGiftcardAmount} />
      </Typography>
      {checkoutMessage ? (
        <Alert
          severity="info"
          icon={false}
          sx={{ width: "100%", gridArea: "m" }}
          className="JS-CheckoutPage-CheckoutMessage"
        >
          <div dangerouslySetInnerHTML={{ __html: checkoutMessage ?? "" }} />
        </Alert>
      ) : null}

      <SendOrderButton isValid={Boolean(isValid)} sx={{ gridArea: "b" }}>
        {payDirect ? <FormattedMessageJamezz id={"Pay"} /> : <FormattedMessageJamezz id={"Order"} />}
      </SendOrderButton>
    </Box>
  );
}
